import { baseUrl } from "../../../config/url-config/index";
import axiosInstance from "../axiosInstance";

const Delete = async (path, data) => {
  try {
    const result = await axiosInstance.delete(`${baseUrl}/${path}`);
    return result;
  } catch (err) {
    throw err;
  }
};

export default Delete;
